import {
  ArrowDownIcon,
  ArrowUpIcon,
  CaretSortIcon,
} from "@radix-ui/react-icons";
import { Column } from "@tanstack/react-table";

import { cn } from "@/lib/utils";

interface DataTableColumnHeaderProps<TData, TValue>
  extends React.HTMLAttributes<HTMLDivElement> {
  column: Column<TData, TValue>;
  title: string;
  enableSorting?: boolean;
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className,
  enableSorting = true,
}: DataTableColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return <div className={cn(className)}>{title}</div>;
  }

  return (
    <div
      className={cn(
        "flex items-center justify-end cursor-pointer space-x-2",
        className,
      )}
    >
      <div
        className="h-8 flex  items-center gap-1 data-[state=open]:bg-accent"
        onClick={() => (enableSorting ? column.toggleSorting() : null)}
      >
        <span>{title}</span>
        {enableSorting ? (
          column.getIsSorted() === "desc" ? (
            <ArrowDownIcon className=" h-3 w-3" />
          ) : column.getIsSorted() === "asc" ? (
            <ArrowUpIcon className="h-3 w-3" />
          ) : (
            <CaretSortIcon className=" h-4 w-4" />
          )
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
